import React from 'react';
import Target from "../../Icons/Target";

const SingleTargetPreview = ({shooting, current}) => {

    return (
        <div className={`w-full aspect-square min-w-[4rem] relative ${(current) ? 'bg-[var(--light-color)]' : ''}`}>
            <Target className="absolute inset-0 w-full h-full object-contain" />
            {shooting.points?.map((point) => (
                <div
                    key={`${shooting.id}-${point.id}-${point.x}-${point.y}`}
                    style={{
                        top: `${point.y}%`,
                        left: `${point.x}%`,
                        transform: "translate(-50%, -50%)"
                    }}
                    className="absolute w-1 h-1 rounded-full bg-red-700"
                ></div>
            ))}
        </div>
    );
};

export default SingleTargetPreview;